// TriggerScheduling.tsx
import { useEffect, useState } from "react";
import Switch from "@imminently/decisively-ui/Switch";
import Label from "@imminently/decisively-ui/Label";
import { Tooltip } from "@/components";
import { useFormContext, useWatch } from "@imminently/decisively-ui/Form";
import { get } from "lodash";
import { GoalField } from "@/components/GoalField";

interface TriggerSchedulingProps {
  scope: string;
  disabled?: boolean;
}

export const TriggerScheduling = ({ scope, disabled }: TriggerSchedulingProps) => {
  const form = useFormContext<any>();
  const switchId = `${scope.replace(/\./g, "-")}-scheduled-toggle`;
  const values = useWatch({ control: form.control });
  const scheduledValue = get(values, `${scope}.scheduled`);
  const [isScheduled, setIsScheduled] = useState(Boolean(scheduledValue));
  const setFieldValue = (name: string, value: any) =>
    form.setValue(name, value, { shouldDirty: true, shouldTouch: true, shouldValidate: true });

  useEffect(() => {
    setIsScheduled(Boolean(scheduledValue));
  }, [scheduledValue]);

  const handleScheduleChange = (checked: boolean) => {
    setIsScheduled(checked);
    if (!checked) {
      setFieldValue(`${scope}.scheduled`, undefined);
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <Tooltip title="Schedule this trigger to be activated sometime after this attribute value is true." placement="bottom-start">
        <div className="flex items-center gap-2">
          <Switch
            id={switchId}
            checked={isScheduled}
            onCheckedChange={handleScheduleChange}
            disabled={disabled}
          />
          <Label htmlFor={switchId} className="mb-0 cursor-pointer">
            Schedule trigger
          </Label>
        </div>
      </Tooltip>

      {isScheduled && (
        <GoalField
          label="Schedule Timestamp"
          name={`${scope}.scheduled`}
          disabled={disabled}
        />
      )}
    </div>
  );
};
